<template>
  <div class="container">
    <div class="hot-cate">
      <div class="tip">热门产品</div>
      <div class="content">
        <div class="left-banner">
          <img src="@/assets/pc/images/channel/left-banner.jpg" alt="" />
        </div>
        <ul class="right-list" v-if="getProductsInfoList.length > 0">
          <li v-for="item of getProductsInfoList.slice(0, 8)" :key="item.id">
            <div class="img">
              <img :src="item.image" alt="" />
            </div>
            <div class="name">{{ item.store_name }}</div>
            <div class="btn" @click="goDetail(item.id)">查看详情</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getProducts } from "@api/public";
export default {
  name: "DiabetesI",
  data() {
    return {
      active: 1,
      params: {
        page: 1,
        limit: 20,
        sid: 122,
        news: 0,
        priceOrder: "",
        salesOrder: ""
      },
      getProductsInfoList: []
    };
  },
  created() {
    this.getProductsInfo();
  },
  methods: {
    getProductsInfo() {
      getProducts(this.params).then(res => {
        this.getProductsInfoList = res.data;
      });
    },
    goDetail(id) {
      this.$router.push({
        path: "/goodsDetail/" + id
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  background #f1fcff
  margin-top 20px
  .hot-cate
    width 1200px
    margin 0 auto
    .tip
      font-size 20px
      color #999
      line-height 60px
      padding-left 10px
      border-bottom 3px solid #ccc
    .content
      display flex
      justify-content space-between
      padding 20px
      .left-banner
        width 230px
        margin-right 15px
        img
          width 100%
      .right-list
        flex 1
        display flex
        flex-wrap wrap
        li
          width 220px
          height 280px
          margin-right 10px
          border 1px solid #ddd
          background #fff
          margin-bottom 18px
          &:nth-child(4n)
            margin-right 0
          .img
            width 150px
            height 150px
            margin 20px auto 0
            img
              width 100%
              height 100%
          .name
            margin-top 6px
            margin-bottom 6px
            text-align center
            font-size 14px
            color #555
            height 40px
          .btn
            width 100px
            margin 0 auto
            height 36px
            line-height 36px
            text-align center
            border 1px solid #ccc
            cursor pointer
</style>
